export default __webpack_public_path__ + "static/media/pbb-color.dd661ca4.svg";